<template>
  <div>
    <beautiful-chat :participants="participants && participants.length ? participants : []" :onMessageWasSent="onMessageWasSent" :messageList="messageList" :isOpen="true" :showEmoji="true" :showFile="true" :showTypingIndicator="showTypingIndicator" :close="() => { }" :open="() => { }" :colors="chatColors" :alwaysScrollToBottom="true" :messageStyling="true" :uploading="CHAT_FILE_UPLOADING" @onType="handleOnType" :showHeader="false" @download-file="viewFile">

      <!-- User avatar-->
      <template v-slot:user-avatar="{ message }">
        <div style="border-radius:50%; font-size: 15px; line-height:25px; text-align:center;background: white; width: 25px !important; height: 25px !important; min-width: 30px;min-height: 30px;margin: 5px; font-weight:bold" v-if="message.author != 'me' && (message.data && message.type != 'system') && message.author != 'carenation-bot'">
          <img :src="messageAvatar(message.author)" alt="" style="border-radius: 50%; width: 100%; height: 100%;">
        </div>
        <div style="border-radius:50%; font-size: 15px; line-height:25px; text-align:center; width: 25px !important; height: 25px !important; min-width: 30px;min-height: 30px;margin: 5px; font-weight:bold; overflow: hidden;" v-if="message.author != 'me' && (message.data && message.type != 'system') && message.author == 'carenation-bot'">
          <img :src="carenationBotImage" alt="" style="padding: 5px; width: 100%; height: 100%; background-color: gray;">
        </div>
      </template>

      <!-- Message body-->
      <template v-slot:text-message-body="{ message }">
        {{ message.data.text }}<br />
        <small v-if="message.data.meta" style="font-size: 60%; font-weight: 200; font-style: italic;">
          {{ message.data.meta }}
        </small>
      </template>

      <!-- System message-->
      <template v-slot:system-message-body="{ message }">
        <span class="fa-stack fa-2x" v-if="message.meta && message.meta.icon && message.meta.icon != 'fas fa-video-slash' && message.meta.icon != 'fas fa-phone-alt'" style="font-size: 0.5em; margin-inline-end: 1em;">
          <i class="fas fa-video fa-stack-2x"></i>
          <i :class="message.meta.icon + ' fa-stack-1x fa-inverse'" style="transform: rotate(45deg); top:0.5em;" v-if="message.meta.icon == 'fas fa-arrow-up' || message.meta.icon == 'fas fa-arrow-down'"> </i>
          <i :class="message.meta.icon + ' fa-stack-1x fa-inverse'" v-else style="left: 10%;"> </i>
        </span>
        <span v-if="message.meta && message.meta.icon && message.meta.icon == 'fas fa-video-slash'" style="font-size: 0.5em; margin-inline-end: 1em;">
          <i :class="message.meta.icon" style="font-size: 1.8em;"> </i>
        </span>
        <span v-if="message.meta && message.meta.icon && message.meta.icon == 'fas fa-phone-alt'" style="font-size: 0.5em; margin-inline-end: 1em;">
          <i :class="message.meta.icon" style="font-size: 1.8em;"> </i>
        </span>
        <span v-if="!message.meta.icon" style="font-size: 0.5em; margin-inline-end: 1em;">
          <i class="fas fa-info-circle" style="font-size: 1.8em;"></i>
        </span><span>{{ message.text }}</span>
        <div v-if="message.meta.time" style="font-size: 0.8em; font-style: italic; padding-top: 0.4em;">{{ message.meta.time }}</div>
        <div v-if="message.meta && !message.meta.time" style="font-size: 0.8em; font-style: italic; padding-top: 0.4em;">{{ message.meta }}</div>
      </template>

      <!-- File message body-->
      <template v-slot:file-message-body="{ message }">
        <div v-if="message.file.type == 'application/pdf' || message.file.type == 'prescription'">
          <div class="sc-message--file-icon" style="display: inline;">
            <i v-if="message.file.type == 'application/pdf'" class="fas fa-file-pdf" style="font-size: 3em; cursor: pointer;" @click="viewFile(message.file)"></i>
            <i v-if="message.file.type == 'prescription'" class="fas fa-file-prescription" style="font-size: 3em; cursor: pointer;" @click="viewFile(message.file)"></i>
          </div>
          <div class="sc-message--file-name" style="display: inline; padding-left: 5px; padding-right: 5px;">
            <a v-if="message.file.type == 'application/pdf'" @click.prevent="viewFile(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
            <a v-if="message.file.type == 'prescription'" @click.prevent="viewFile(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
          </div>
          <div v-if="message.text" class="sc-message--file-text" style="padding: 1em 0 0 0">
            {{ message.text }}
            <span v-if="message.meta">
              <small style="font-size: 60%; font-weight: 200; font-style: italic;">
                {{ message.meta }}
              </small>
            </span>
          </div>
          <div v-else class="sc-message--file-text-meta" style="padding: 1em 0 0 0">
            <span v-if="message.meta">
              <small style="font-size: 60%; font-weight: 200; font-style: italic;">
                {{ message.meta }}
              </small>
            </span>
          </div>
        </div>

        <div v-if="message.file.type.includes('image/') || message.file.type.includes('video/')">
          <div class="sc-message--file-icon">
            <dynamic-image v-if="message.file.type.includes('image/')" :file-id="message.file.url" class="sc-image" @click.native="showPreview(message.file)" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;" />
            <dynamic-video v-if="message.file.type.includes('video/')" :file-id="message.file.url" class="sc-video" controlsList="nodownload" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0;" :options="{ controls: true }" />
          </div>
          <div class="sc-message--file-name" style="display: flex; padding: 1em; background-color: #00000036 !important; border-bottom-left-radius: 3px; border-bottom-right-radius: 3px;">
            <a v-if="message.file.type.includes('image/')" style="flex: 2; display: grid; justify-items: left; align-items: center;" @click.prevent="showPreview(message.file)" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
            <a v-else style="flex: 2; display: grid; justify-items: left; align-items: center;" @click.prevent="" :href="message.file.url ? message.file.url : '#'" target="_blank">{{ message.file.name || '' }}</a>
            <i class="fas fa-arrow-down" style="cursor: pointer; font-size: 3em; margin-left: auto;" @click="viewFile(message.file)"></i>
          </div>
          <div v-if="message.text" class="sc-message--file-text">
            {{ message.text }}
            <p v-if="message.meta" style="text-align: right; font-size: xx-small; margin-bottom: -1em;">
              {{ message.meta }}
            </p>
          </div>
          <div v-else class="sc-message--file-text">
            <p v-if="message.meta" style="text-align: right; font-size: xx-small; margin-bottom: -1em;">
              {{ message.meta }}
            </p>
          </div>
        </div>
      </template>

      <!-- Send file preview -->
      <template v-slot:file-preview="{ file }">
        <i v-if="file.type == 'application/pdf'" class="fas fa-file-pdf" id="preview-pdf" />
        <img v-if="file.type.includes('image/')" class="rounded mx-auto d-block" id="preview-img" :src="getFileSrc(file)" />
        <video v-if="file.type.includes('video/')" class="rounded mx-auto d-block" id="preview-video" :src="getFileSrc(file)"></video>
      </template>

    </beautiful-chat>

    <div v-if="showPreviewModal" class="preview-modal">

      <dynamic-image v-if="previewFile.type.includes('image/')" :file-id="previewFile.url" class="sc-image" style="border-bottom-left-radius: 0; border-bottom-right-radius: 0; max-width:100%; max-height: 100%;" />

      <div style="position: absolute; top: 1em; inset-inline-end: 1em; background: #00000070; padding: 1em; border-radius: 3px;">
        <i class="fas fa-arrow-down" style="cursor: pointer; color: white; font-size: 2em; margin-right: 1em;" @click="viewFile(previewFile)"></i>
        <i class="fas fa-times" @click="showPreviewModal = false" style="cursor: pointer; color: white; font-size: 2em;"></i>
      </div>

    </div>
    <call-notification v-if="callNotification" :caller="caller" :callType="'incoming'" @call-declined="onCallDeclined()" @call-accepted="onCallAccepted()" @call-missed="onCallMissed()">
    </call-notification>
  </div>
</template>

<script>
import CallNotification from "../../../components/CallNotification.vue";
import socket from "../../../services/socket";
export default {
  props: {
    context: {
      default: "ward",
    },
    id: {
      default: "",
    },
    headerText: {
      default: "",
    },
    showHeaderText: {
      default: false,
    },
    participants: {
      default: [],
    },
  },
  components: {
    CallNotification,
  },
  data() {
    return {
      callNotification: false,
      caller: {},
      remoteUser: null,
      chatColors: {
        header: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        launcher: {
          bg: "#4e8cff",
        },
        messageList: {
          bg: "#ffffff",
        },
        sentMessage: {
          bg: "var(--color-primary)",
          text: "#ffffff",
        },
        receivedMessage: {
          bg: "#eaeaea",
          text: "#222222",
        },
        userInput: {
          bg: "#f4f7f9",
          text: "#565867",
        },
      },
      CHAT_FILE_UPLOADING: false,
      messages: [],
      showTypingIndicator: "",
      defaultImage: require("@/assets/img/proAvatar.png"),
      previewFile: null,
      showPreviewModal: false,
    };
  },
  async mounted() {
    await this.getMessages();

    this.initiateOnGoingCall();

    socket.emit("joinRoom", {
      type: "appointment",
      id: this.id,
      userId: this.user._id,
    });

    socket.on("newChatMessage", async (message) => {
      console.log(message);
      if (message.chatMessage.username != this.user.username) {
        //TODO - Refector properly to handle all cases
        if (
          message.chatMessage.to == this.user.patientId ||
          this.user.username
        ) {
          if (
            message.chatMessage.status &&
            message.chatMessage.status == "initiated"
          ) {
            for (let participant of this.participants) {
              if (participant.id == message.chatMessage.username) {
                this.remoteUser = participant;
              }
            }
            this.caller.img = this.remoteUser.imageUrl || this.defaultImage;
            this.caller.name = this.remoteUser.name;
            this.callNotification = true;
            $(".sc-user-input--text").blur();
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "ended"
          ) {
            this.$emit("callEnded");
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "cancelled"
          ) {
            this.callNotification = false;
          } else if (
            message.chatMessage.status &&
            message.chatMessage.status == "missed"
          ) {
            this.callNotification = false;
          }
        }
        this.getMessages();
      }
    });

    socket.on("chatTyping", (data) => {
      if (data.typing && data.userId != this.user.username) {
        this.showTypingIndicator = data.userId;
      }
      if (!data.typing) {
        this.showTypingIndicator = "";
      }
    });
  },
  computed: {
    messageList() {
      let messageList = [];
      for (const msg of this.messages) {
        if (msg.type == "text") {
          let newMessage = {
            author: msg.username == this.user.username ? "me" : msg.username,
            data: { text: msg.content, meta: msg.time },
            type: msg.type,
          };
          if (msg.headerText) {
            newMessage.headerText = msg.headerText;
          }
          if (msg.name != "Carenation bot") {
            newMessage["fullName"] = msg.name;
          }
          messageList.push(newMessage);
        } else if (msg.type == "file") {
          let newMessage = {
            author: msg.username == this.user.username ? "me" : msg.username,
            data: {
              file: {
                name: msg.content,
                url: msg.fileId,
                type: msg.fileType,
              },
              meta: msg.time,
              text: msg.text,
            },
            type: msg.type,
          };
          if (msg.name != "Carenation bot") {
            newMessage.data["fullName"] = msg.name;
          }
          messageList.push(newMessage);
        } else if (msg.type == "call" && msg.content) {
          let newMessage = {
            author: msg.username == this.user.username ? "me" : msg.username,
            data: { text: msg.status, meta: { time: msg.time } },
            type: "system",
          };
          //handling icons and text of video call status message
          if (
            msg.username == this.user.username &&
            (msg.status == "initiated" ||
              msg.status == "accepted" ||
              msg.status == "ended" ||
              msg.status == "missed")
          ) {
            newMessage.data.meta.icon = "fas fa-arrow-up";
          } else if (
            msg.username != this.user.username &&
            (msg.status == "initiated" ||
              msg.status == "accepted" ||
              msg.status == "ended" ||
              msg.status == "missed")
          ) {
            newMessage.data.meta.icon = "fas fa-arrow-down";
          } else if (msg.status == "declined") {
            newMessage.data.meta.icon = "fas fa-video-slash";
          } else if (msg.status == "cancelled") {
            newMessage.data.meta.icon = "fas fa-video-slash";
          }
          if (msg.status == "missed") {
            newMessage.data.text = `Missed call ${msg.firstName} ${msg.lastName}`;
          } else if (msg.status == "declined") {
            newMessage.data.text = `Call declined ${msg.firstName} ${msg.lastName}`;
          } else if (msg.status == "cancelled") {
            newMessage.data.text = `Call cancelled ${msg.firstName} ${msg.lastName}`;
          } else if (msg.status == "initiated") {
            newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
          } else if (msg.status == "accepted") {
            newMessage.data.text = `Call accepted ${msg.firstName} ${msg.lastName}`;
          } else if (msg.status == "ended") {
            newMessage.data.text = `Call ended ${msg.firstName} ${msg.lastName}`;
          }
          messageList.push(newMessage);
        } else if (msg.type == "emoji") {
          let newMessage = {
            author: msg.username == this.user.username ? "me" : msg.username,
            data: { emoji: msg.content, meta: msg.time },
            type: msg.type,
          };
          messageList.push(newMessage);
        } else if (msg.type == "audio call" && msg.content) {
          let newMessage = {
            author: msg.username == this.user.username ? "me" : msg.username,
            data: {
              text: msg.status,
              meta: { time: msg.time, icon: "fas fa-phone-alt" },
            },
            type: "system",
          };
          if (msg.status == "audio call initiated") {
            newMessage.data.text = `Call initiated ${msg.firstName} ${msg.lastName}`;
          }
          messageList.push(newMessage);
        } else if (msg.carecoJoinedMessage || msg.carecoExitedMessage) {
          let newMessage = {
            author: msg.username,
            data: { text: msg.content, meta: msg.time },
            type: msg.type,
          };
          messageList.push(newMessage);
        }
      }

      return messageList;
    }
  },
  methods: {
    initiateOnGoingCall() {
      let acceptedCall = (this.messages && this.messages.length) ? this.messages.findLast((element) => element.type === 'call' && element.status === 'accepted') : null;
      if (acceptedCall) {
        this.$emit("callAccepted");
      }
    },
    async onMessageWasSent(message) {
      try {
        if (this.context == "appointment") {
          socket.emit("chatTyping", {
            appointmentId: this.id,
            userId: this.user.username,
            typing: false,
          });
        } else {
          socket.emit("chatTyping", {
            roomId: this.id,
            userId: this.user.username,
            typing: false,
          });
        }
        let that = this;
        if (message.type == "text" || message.type == "system") {
          let msg = {
            username: this.user.username,
            name: `${this.user.firstName} ${this.user.lastName}`,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            content: message.data.text,
            time: moment().format("DD-MM-YYYY, h:mm a"),
            type: message.type,
          };
          this.updateMessages(msg);
          $(".sc-user-input--text").focus();
        } else if (message.type == "file") {
          that.CHAT_FILE_UPLOADING = true;
          let msg = {
            username: this.user.username,
            name: `${this.user.firstName} ${this.user.lastName}`,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            content: message.data.text,
            fileId: "",
            text: "",
            time: moment().format("DD-MM-YYYY, h:mm a"),
            type: message.type,
            fileType: message.data.file.type,
          };
          if (message.data.text) {
            msg.text = message.data.text;
          }
          console.log(message.data.file);

          this.retrievePresignedUrl(
            message.data.file,
            async function (url, fileId, file) {
              await that.uploadChatFile(file, url, fileId);
              msg.fileId = fileId;
              that.updateMessages(msg);
              that.CHAT_FILE_UPLOADING = false;
            }
          );
        } else if (message.type == "emoji") {
          let msg = {
            username: this.user.username,
            name: `${this.user.firstName} ${this.user.lastName}`,
            firstName: this.user.firstName,
            lastName: this.user.lastName,
            content: message.data.emoji,
            time: moment().format("DD-MM-YYYY, h:mm a"),
            type: message.type,
          };
          this.updateMessages(msg);
        }
      } catch (e) {
        this.CHAT_FILE_UPLOADING = false;
        console.log(e);
      }
    },

    async updateMessages(newMessage) {
      if (this.context === "bed") {
        newMessage.headerText = this.headerText;
      }
      let response = null;

      if (this.context === "appointment") {
        response = await this.$store.dispatch("updateMessages", {
          appointmentId: this.id,
          newMesssage: newMessage,
        });
      } else if (this.context === "ward" || this.context === "bed") {
        response = await this.$store.dispatch("updateIcuMessages", {
          roomId: this.id,
          newMesssage: newMessage,
        });
      }

      if (response && response._id) {
        this.messages.push(response.message);
        this.$forceUpdate();
        if (this.context == "appointment") {
          socket.emit("newChatMessage", {
            appointmentId: this.id,
            chatMessage: newMessage,
          });
        } else {
          socket.emit("newChatMessage", {
            roomId: this.id,
            chatMessage: newMessage,
          });
        }
      }
    },

    async retrievePresignedUrl(file, cb) {
      let response = await this.$store.dispatch("getPresignedUrl", file.name);

      if (response) {
        cb(response.url, response.fileId, file);
      } else {
        swal.fire({
          title: this.$t("message.File couldn't be shared!"),
          type: "error",
          timer: 5000,
        });
      }
    },

    async uploadChatFile(file, url, fileId) {
      let fileDetails = {
        name: file.name,
        type: file.type,
        size: file.size,
        fileId: fileId,
      };

      //Save file to FileServer
      await this.$store.dispatch("uploadChatFileToMinio", {
        url: url,
        file: file,
      });

      this.$emit("file-upload", fileDetails);
      return fileDetails;
    },

    async viewFile(file) {
      let that = this;
      try {
        that.loader = that.$loading.show({
          // Optional parameters
          container: null,
          canCancel: false,
        });
        //get file from server
        let fileArrayBuffer = await that.$store.dispatch(
          "getFile",
          file.fileId || file.url
        );
        let fileType = file.type;
        if (fileType == "prescription") {
          fileType = "application/pdf";
        }
        let pdfBlob = new Blob([fileArrayBuffer], { type: fileType });

        let storageLocation = "";

        if (typeof device !== "undefined") {
          switch (device.platform) {
            case "Android":
              //using cacheDirectory to clear the storage after preview
              storageLocation = cordova.file.cacheDirectory;
              break;

            case "iOS":
              storageLocation = cordova.file.documentsDirectory;
              break;
          }

          let folderPath = storageLocation;

          window.resolveLocalFileSystemURL(
            folderPath,
            function (dir) {
              dir.getFile(
                file.name,
                {
                  create: true,
                },
                function (file) {
                  file.createWriter(
                    function (fileWriter) {
                      fileWriter.write(pdfBlob);

                      fileWriter.onwriteend = function () {
                        var url = file.nativeURL;
                        cordova.plugins.fileOpener2.open(url, pdfBlob.type, {
                          error: function error(err) {
                            console.error(err);
                            that.loader.hide();
                            alert(this.$t("message.Unable to download"));
                          },
                          success: function success() {
                            that.loader.hide();
                            console.log("success with opening the file");
                          },
                        });
                      };

                      fileWriter.onerror = function (err) {
                        that.loader.hide();
                        alert(this.$t("message.Unable to download"));
                        console.error(err);
                      };
                    },
                    function (err) {
                      that.loader.hide();
                      // failed
                      alert(this.$t("message.Unable to download"));
                      console.error(err);
                    }
                  );
                },
                function (err) {
                  that.loader.hide();
                  alert(this.$t("message.Unable to download"));
                  console.error(err);
                }
              );
            },
            function (err) {
              that.loader.hide();
              alert(this.$t("message.Unable to download"));
              console.error(err);
            }
          );
        }
      } catch (e) {
        that.loader.hide();
        console.log(e);
      }
    },

    async getMessages() {
      if (this.context === "appointment") {
        this.messages = await this.$store.dispatch(
          "getAppointmentMessages",
          this.id
        );
      } else if (this.context === "ward") {
        this.messages = await this.$store.dispatch("getIcuMessages", this.id);
      } else if (this.context === "bed") {
        this.messages = await this.$store.dispatch(
          "getIcuBedMessages",
          this.id
        );
      }
      this.$forceUpdate();
    },

    messageAvatar(id) {
      //TODO: add participants to show profile pic
      for (let participant of this.participants) {
        if (participant.id == id && participant.imageUrl) {
          return participant.imageUrl;
        }
      }
      return this.defaultImage;
    },

    showPreview(file) {
      this.previewFile = file;
      this.showPreviewModal = true;
    },

    getFileSrc(file) {
      let fileSrc = URL.createObjectURL(file);
      return fileSrc;
    },

    handleOnType() {
      setTimeout(() => {
        let inputText = document.getElementsByClassName(
          "sc-user-input--text"
        )[0].innerText;

        if (inputText.length > 0) {
          if (this.context == "appointment") {
            socket.emit("chatTyping", {
              appointmentId: this.id,
              userId: this.user.username,
              typing: true,
            });
          } else {
            socket.emit("chatTyping", {
              roomId: this.id,
              userId: this.user.username,
              typing: true,
            });
          }
        } else {
          if (this.context == "appointment") {
            socket.emit("chatTyping", {
              appointmentId: this.id,
              userId: this.user.username,
              typing: false,
            });
          } else {
            socket.emit("chatTyping", {
              roomId: this.id,
              userId: this.user.username,
              typing: false,
            });
          }
        }
      }, 1000);
    },

    onCallMissed() {
      this.callNotification = false;
    },
    async onCallAccepted() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.id,
        status: "accepted",
      });

      if (response && response._id) {
        //Get appointment messages

        let message = {
          username: this.user.patientId || this.user.username,
          status: "accepted",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.id,
          chatMessage: message,
        });

        this.getMessages();
        this.$emit("callAccepted");
      }
    },
    async onCallDeclined() {
      this.callNotification = false;

      let response = await this.$store.dispatch("updateCallStatus", {
        appointmentId: this.id,
        status: "declined",
      });

      if (response && response._id) {
        let message = {
          username: this.user.patientId || this.user.username,
          status: "declined",
          to: this.remoteUser.id,
        };
        socket.emit("newChatMessage", {
          appointmentId: this.id,
          chatMessage: message,
        });
        this.getMessages();
      }
    },
  },
  beforeDestroy() {
    if (this.context == "appointment") {
      socket.emit("chatTyping", {
        appointmentId: this.id,
        userId: this.user.username,
        typing: false,
      });
    } else {
      socket.emit("chatTyping", {
        roomId: this.id,
        userId: this.user.username,
        typing: false,
      });
    }

    socket.emit("leaveRoom", {
      type: "appointment",
      id: this.id,
      userId: this.user._id,
    });
  },
};
</script>

<style scoped>
#chat-message > div {
  height: 100%;
}

.ios #chat-message > div {
  height: 98%;
}

/deep/ .sc-chat-window {
  position: unset !important;
  padding-top: 2em;
  height: 100%;
  width: 100%;
  max-height: 100%;
}

/deep/ .sc-message--file {
  max-width: 35vh;
}

/deep/ .sc-message-list {
  height: 95% !important;
  background-image: url("../../../assets/img/background.png") !important;
  background-color: #212529 !important;
  padding-top: 0em !important;
  padding-bottom: 0em !important;
}

@media (max-width: 450px) {
  /deep/ .sc-message {
    width: 100% !important;
  }
}

/deep/ .sc-message:first-of-type {
  margin-top: 4em !important;
}

/deep/ .sc-user-input--button svg {
  height: 25px !important;
  width: 25px !important;
}

/deep/ .full-name {
  font-weight: 600;
  color: var(--color-primary);
}

/deep/.sc-message--file .full-name {
  margin-top: -0.7em;
  margin-bottom: 0.4em;
}

/deep/ .sent .full-name {
  display: none;
}

/deep/.content-container {
  height: 100% !important;
}

/deep/ .file-container {
  border-top-left-radius: 0px;
}

/deep/ .fa-stack-1x,
.fa-stack-2x {
  text-align: inherit;
}

/deep/ .modal-content .modal-body {
  padding-left: 0px;
  padding-right: 0px;
}

/deep/ .sc-message--system {
  opacity: 0.9 !important;
  color: #0d2747 !important;
  background-color: #f5f5f5 !important;
}

/deep/ .sc-message--system p {
  color: rgb(34, 34, 34) !important;
}

/deep/ label {
  margin-bottom: 0;
}

/deep/ .sc-message--content.received .sc-message--file i {
  color: rgb(134, 134, 134);
}

/deep/ .sc-image {
  max-height: 18em;
  max-width: 100%;
  min-width: 100%;
}

/deep/ .sc-video {
  max-width: 100%;
}

/deep/ .bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  padding-left: 2.5em !important;
}

/deep/ .sc-user-input {
  background: #e6e6e6 !important;
  border-radius: 0px !important;
}

/deep/ .sc-user-input--text {
  color: rgb(86, 88, 103) !important;
  background-color: white !important;
  border-radius: 60px !important;
  margin-top: 0.5em !important;
  margin-bottom: 0.5em !important;
  padding-top: 0.5em !important;
  padding-bottom: 0.5em !important;
  line-height: 2 !important;
}

/deep/ .disable-input .sc-user-input {
  display: none !important;
}

/deep/.float-input-label {
  position: absolute;
  font-size: 0.65em;
  padding-left: 2em;
  color: var(--color-primary);
  top: 0.2em;
}

/deep/.float-input-label.age {
  top: 0.9em;
}

/deep/ .sc-user-input--file-icon-wrapper {
  margin-bottom: 0em;
}

p {
  line-height: unset;
}

.preview-modal {
  position: absolute;
  top: 0em;
  left: 0px;
  width: 100%;
  background: rgba(128, 128, 128, 0.83);
  z-index: 1;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2;
}

/deep/ .file-container {
  max-height: 75vh;
}

/deep/ #preview-img {
  max-height: 68vh;
}

/deep/ #preview-video {
  max-height: 68vh;
}
</style>
